import { useMutation, useQueryClient } from '@tanstack/react-query';

import { archiveExpertMutation } from '../api/mutations/archiveExpertMutation';
import { graphQLClient } from '@/client/services/api/clients/graphqlClient';
import { useNavigate } from 'react-router-dom';
import { useToastStore } from '@/client/services/state/toastStore';
import { useTranslation } from 'react-i18next';

export const useArchiveExpert = () => {
  const { t } = useTranslation();
  const { setToast } = useToastStore();
  const navigate = useNavigate();

  const queryClient = useQueryClient();

  const archiveExpert = useMutation({
    mutationFn: async (expertId: string) => {
      const data = await graphQLClient.request(archiveExpertMutation, { expertId });

      return data.archiveExpert;
    },
    onSuccess: () => {
      setToast({
        show: true,
        status: 'success',
        title: t('admin.aiAgent.experts.archiveSuccess'),
      });

      queryClient
        .invalidateQueries({ queryKey: ['listExperts'] })
        .then(() => navigate('/admin/eddy/experts'));
    },
    onError: () => {
      setToast({
        show: true,
        status: 'error',
        title: t('admin.aiAgent.experts.archiveError'),
      });
    },
  });

  return {
    archiveExpert,
  };
};
